export default "__VITE_ASSET__D1x_xhOX__"